import {Controller} from "stimulus"

var delayTimer;
export default class extends Controller {
    connect() {
        console.log("hello from permitting square footage controller");
    }

    updateReport(e) {
        console.log("report changed")
        clearTimeout(delayTimer);
        delayTimer = setTimeout(function () {
            const dateFrom = document.getElementById("date_from")
            const dateTo = document.getElementById("date_to")
            if (dateFrom.value != "" && dateTo.value != "" || dateFrom.value == "" && dateTo.value == "") {
                document.getElementById("flash-area").innerHTML = ""
                const jurisdiction = document.getElementById("jurisdiction_id")
                const classification = document.getElementById("classification")
                const builtType = document.getElementById("build_type")
                let title = "Square Footage Applied For: "
                if (dateFrom.value != "") {
                    title += dateFrom.value + " to " + dateTo.value;
                }
                let reportUrl = 'chart?title=' + title +
                    '&data_source=permitting_reports_permitting_square_footage_path&date_from=' + dateFrom.value +
                    '&date_to=' + dateTo.value +
                    '&build_type=' + builtType.value
                if (jurisdiction) {
                    reportUrl = reportUrl + '&jurisdiction_id=' + jurisdiction.value
                }
                window.location.href = reportUrl;
            } else {
                document.getElementById("flash-area").innerHTML = ('<div  class="warn">Please select a date range or leave both fields blank.</div>')
                dateFrom.classList.add('required-field')
                dateTo.classList.add('required-field')
            }

        }, 2500)


    }

}